module.exports = __webpack_public_path__ + "static/media/CSL_Esports_Primary_White.83abdc5d.png";